import { useEffect, useState } from "react";
import {
  Autocomplete,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
} from "../../../../components";
import { value } from "../../../../helpers";
import {
  ColecoesService,
  GrupoProdutosService,
  MarcasService,
  SessionService,
  TagsService
} from "../../../../services";
import { responseErros } from "../../../../utils";
import { useFiltrosRelatoriosHandlers } from "../../components/use-filtros-relatorios-handlers";

const colecoesService = new ColecoesService();
const marcasService = new MarcasService();
const tagsService = new TagsService();
const grupoProdutosService = new GrupoProdutosService();

const FormFiltroAvancadoEstoqueFinanceiro = ({
  filtrosAvancados,
  setFiltrosAvancados,
  filtrosAplicadosImpressao,
  setFiltrosAplicadosImpressao,
}) => {
  const [grupoProdutoList, setGrupoProdutoList] = useState([]);
  const [tags, setTags] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [colecoes, setColecoes] = useState([]);
  const { onChangeInput, onChangeAutocomplete } =
    useFiltrosRelatoriosHandlers(
      setFiltrosAvancados,
      setFiltrosAplicadosImpressao
    );

  const sessionService = new SessionService();
  const usuario = sessionService.getUsuario();
  const empresa = sessionService.getEmpresa();
  const listaTipos = [
    {
      label: "Simples",
      value: "simples",
    },
    {
      label: "Grade",
      value: "grade",
    },
    {
      label: "Kit",
      value: "kit",
    },
  ];

  useEffect(() => {
    setEstadoInicial();

    buscarGruposProduto();
    buscarMarcas();
    buscarColecoes();
    buscarTags();
  }, []);

  const buscarGruposProduto = () => {
    const filtros = {
      attributes: ['id', 'codigo', 'descricao'],
      disabledInclude: true,
      nonPaginated: true,
    };
    grupoProdutosService.getAll(filtros).then((result) => {
      if (!result.isAxiosError) {
        setGrupoProdutoList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  // const onInputChangeProdutos = (event) => {
  //   if (event.key === "Enter" && inputRef.current === document.activeElement) {
  //     const eventValue = event.target?.value;
  //     if (eventValue?.length >= 2) {
  //       const filtros = {
  //         codigo: eventValue,
  //         codigoBarra: eventValue,
  //         descricao: eventValue,
  //       };
  //       setLoadingAutoComplete(true);
  //       buscarProdutos(filtros);
  //     }
  //   }
  // };

  const onChangeMultiple = (valores, name, nomeImpressao) => {
    if (!valores?.length) {
      resetarFiltros(name, nomeImpressao);
      return;
    }
    setFiltrosAvancados((prevState) => ({
      ...prevState,
      [name]: valores.map(({ id }) => id),
    }));
    setFiltrosAplicadosImpressao((prevState) => ({
      ...prevState,
      [nomeImpressao]: formatValorFiltroImpressao(
        valores,
        name
      ),
    }));
  };

  function resetarFiltros(name, nomeImpressao) {
    setFiltrosAvancados((prevState) => {
      const prevStateTemp = { ...prevState };
      delete prevStateTemp[name];
      return prevStateTemp;
    });

    setFiltrosAplicadosImpressao((prevState) => {
      const prevStateTemp = { ...prevState };
      delete prevStateTemp[nomeImpressao];
      return prevStateTemp;
    });
  }

  function formatValorFiltroImpressao(valores, name) {
    switch (name) {
      case "tags":
        return valores.map((valor) => valor.descricao);
      case "marcaId":
        return valores.map((valor) => valor.nome);
      case "colecaoId":
        return valores.map((valor) => valor.descricao);
      default:
        return valores;
    }
  }

  function setEstadoInicial() {
    const filtros = {
      ...filtrosAvancados,
      empresaId: [empresa.id],
    };
    let filtrosImpressao = {};
    if (usuario.acessosEmpresas?.length) {
      filtrosImpressao = {
        ...filtrosAplicadosImpressao,
        ["Empresas-Associadas"]: empresa.razaoSocial,
      };
    }

    setFiltrosAvancados(filtros);
    setFiltrosAplicadosImpressao(filtrosImpressao);
  }

  const buscarTags = async function () {
    const filtros = {
      nonPaginated: true,
      ativado: true,
      tipo: "PRODUTO",
    };
    const result = await tagsService.getAll(filtros);
    if (!result.isAxiosError) {
      setTags(result.data);
    } else {
      responseErros(result);
    }
  };

  const buscarMarcas = async function (filter) {
    const result = await marcasService.getAll(filter);
    if (!result.isAxiosError) {
      setMarcas(result.data.rows);
    } else {
      responseErros(result);
    }
  };

  const buscarColecoes = async function (filter) {
    const result = await colecoesService.getAll(filter);
    if (!result.isAxiosError) {
      setColecoes(result.data.rows);
    } else {
      responseErros(result);
    }
  };

  const getMultipleAutocompleteValues = (valores, lista) => {
    if (valores) {
      return valores.map((valor) => lista.find((item) => item.id === valor));
    }
    return [];
  };

  function onChangeMultipleEmpresas(empresas) {
    if (empresas.length === 0) {
      return;
    }
    setFiltrosAvancados((prevState) => ({
      ...prevState,
      empresaId: empresas.map(({ id }) => id),
    }));
    setFiltrosAplicadosImpressao((prevState) => ({
      ...prevState,
      "Empresas-Associadas": empresas
        .map(({ razaoSocial }) => razaoSocial)
        .join(" | "),
    }));
  }

  return (
    <>
      {usuario.acessosEmpresas?.length > 0 && (
        <>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Autocomplete
              multiple
              id="empresaId"
              name="empresaId"
              options={usuario.acessosEmpresas}
              noOptionsText="Sem opções"
              autoHighlight
              disablePortal
              filterSelectedOptions
              getOptionLabel={(option) => option?.razaoSocial || ""}
              onChange={(_, newValue) => onChangeMultipleEmpresas(newValue)}
              value={value.multiple(
                usuario.acessosEmpresas || [],
                filtrosAvancados["empresaId"]
                  ? filtrosAvancados["empresaId"]
                  : ""
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  required
                  label="Empresas"
                  margin="normal"
                />
              )}
            />
          </Grid>
        </Grid>
        <Divider sx={{ mt: 2, mb: 1, border: "1px solid grey" }}/>
        </>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="grupoProdutoId"
              name="grupoProdutoId"
              options={grupoProdutoList}
              noOptionsText="Sem opções"
              autoHighlight
              disablePortal
              getOptionLabel={(option) => (option ? option.descricao : "")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Grupo de Produto"
                  variant="outlined"
                />
              )}
              onChange={(_, newValue) => {
                onChangeAutocomplete(
                  "grupoProdutoId",
                  newValue,
                  "Grupo de Produtos"
                );
              }}
              value={value.autoComplete(grupoProdutoList, filtrosAvancados?.grupoProdutoId)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <Select
            label="Tipo"
            id="tipo"
            name="tipo"
            margin="normal"
            variant="outlined"
            value={value.text(filtrosAvancados?.tipo)}
            onChange={(event) => onChangeInput(event, "Tipo")}
            SelectProps={{
              MenuProps: {
                disablePortal: true,
                PaperProps: {
                  sx: {
                    zIndex: 1600, 
                  },
                },
              },
            }}
          >
            {listaTipos.map((tipo) => (
              <MenuItem key={tipo.value} value={tipo.value}>
                {tipo.label}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={6}>
          <Autocomplete
            multiple
            id="tags"
            name="tags"
            options={tags}
            noOptionsText="Sem opções"
            autoHighlight
            disablePortal
            filterSelectedOptions
            getOptionLabel={(option) => {
              return (
                <div>
                  <i
                    className="ph-fill ph-bookmark-simple"
                    style={{ color: `${option?.cor}`, marginRight: "10px" }}
                  ></i>
                  {option?.descricao}
                </div>
              );
            }}
            onChange={(_, newValue) => onChangeMultiple(newValue, "tags", "Tags")}
            value={getMultipleAutocompleteValues(
              filtrosAvancados?.tags,
              tags
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                margin="normal"
                label="Tags"
              />
            )}
          />
        </Grid>
        <Grid item xs={6}>
          <Autocomplete
            multiple
            id="marcaId"
            name="marcaId"
            options={marcas}
            noOptionsText="Sem opções"
            autoHighlight
            disablePortal
            filterSelectedOptions
            getOptionLabel={(option) => option?.nome || ""}
            onChange={(_, newValue) => onChangeMultiple(newValue, "marcaId", "Marcas")}
            value={getMultipleAutocompleteValues(
              filtrosAvancados?.marcaId,
              marcas
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                margin="normal"
                label="Marcas"
              />
            )}
          />
        </Grid>
        <Grid item xs={6}>
          <Autocomplete
            multiple
            id="colecaoId"
            name="colecaoId"
            options={colecoes}
            noOptionsText="Sem opções"
            autoHighlight
            disablePortal
            filterSelectedOptions
            getOptionLabel={(option) => option?.descricao || ""}
            onChange={(_, newValue) => onChangeMultiple(newValue, "colecaoId", "Coleções")}
            value={getMultipleAutocompleteValues(
              filtrosAvancados?.colecaoId,
              colecoes
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                margin="normal"
                label="Coleções"
              />
            )}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default FormFiltroAvancadoEstoqueFinanceiro;
